import type { AxiosError } from '@ori/axios';
import { action, runInAction, observable } from 'mobx';

import { BaseStore } from './BaseStore';
import { MAX_AMOUNT_ITEMS_TO_RENDER } from '~/constants';
import type { Question, SearchResult } from '~/models/supportCenter';

export class SearchResultStore extends BaseStore {
  @observable
  searchQuery = '';

  @observable
  searchQuestions: Question[] = [];

  @observable
  searchResult: SearchResult = { Results: [], TotalCount: 0 };

  @observable
  itemsToSkip = 0;

  private readonly itemsToTake = MAX_AMOUNT_ITEMS_TO_RENDER;

  @observable
  isFirstLoad = true;

  @action
  setSearchQuery = (query: string) => {
    this.searchQuery = query;
  };

  @action
  setItemsToSkipForNextPage = () => {
    this.itemsToSkip += this.itemsToTake;
  };

  @action
  resetItemsToSkip = () => {
    this.itemsToSkip = 0;
  };

  @action
  loadSearchResults = async (query: string) => {
    this.networkError = undefined;
    const mark = this.areMocksEnabled ? '' : '?';
    const queryParameter = `${query}&skip=${this.itemsToSkip}&take=${this.itemsToTake}`;
    const url = `/applications/supportCenter/search${mark}query=${queryParameter}`;
    const response = await this.getUrl<SearchResult>(url);

    if (response.data) {
      runInAction(() => {
        this.searchResult = response.data;

        if (this.searchQuery !== query) {
          this.searchQuestions = [];
          this.resetItemsToSkip();
        }

        if (this.searchResult.TotalCount < MAX_AMOUNT_ITEMS_TO_RENDER) {
          this.searchQuestions = this.searchResult.Results;
        } else {
          this.searchQuestions = [...this.searchQuestions, ...this.searchResult.Results];
        }

        if (this.searchResult.TotalCount === 0) {
          this.searchQuestions = [];
        }
      });
    }

    if (response.error !== undefined) {
      runInAction(() => {
        this.networkError = response.error as AxiosError;
      });
    }

    this.isFirstLoad = false;

    return response;
  };

  @action
  resetSearchResults = () => {
    this.searchResult = { Results: [], TotalCount: 0 };
    this.searchQuestions = [];
    this.setSearchQuery('');
  };
}
